import { CarPart } from "types/CarPart";

import client from "./client";

interface Body {
  damagedParts: CarPart[];
}

export const completeSession = (sessionId: string, clientId: string, body: Body) =>
  client.post(`/client/${clientId}/session/${sessionId}/complete`, body, {
    headers: { session_id: sessionId },
  });
